import type { SVGProps } from 'react';

const SvgClassNew = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_1234_40759)'>
      <circle cx={12} cy={12} r={12} fill='#FF5A5A' />
      <path
        d='M16.5 7.5V16.5H14.3746L10.0651 11.2169H9.99186V16.5H7.5V7.5H9.65472L13.9202 12.7831H14.0081V7.5H16.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1234_40759'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassNew;
